import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { ProjectId } from 'api/models';
import { Action, EventType, ObjectType, SocketData } from 'api/pushes';
import { Space as SpaceApi } from 'api/space';
import { getProjectSpacesQueryKey } from 'queries';
import { useProjectWSUpdates } from '../use-project-ws-updates';

export const useProjectSpaceWebsocket = (projectId: ProjectId) => {
  const queryClient = useQueryClient();
  const webSocketsHandler = useCallback(
    async (socketData: SocketData<SpaceApi>) => {
      const { action } = socketData;

      switch (action) {
        case Action.Update:
        case Action.Create:
        case Action.Delete:
          await queryClient.invalidateQueries(
            getProjectSpacesQueryKey(projectId),
          );
          break;
        default:
      }
    },
    [projectId, queryClient],
  );

  useProjectWSUpdates(
    projectId[1],
    webSocketsHandler,
    EventType(Action.Create, ObjectType.Space),
  );

  useProjectWSUpdates(
    projectId[1],
    webSocketsHandler,
    EventType(Action.Update, ObjectType.Space),
  );

  useProjectWSUpdates(
    projectId[1],
    webSocketsHandler,
    EventType(Action.Delete, ObjectType.Space),
  );
};
